import { useBreakpoint } from '@/hooks/useBreakpoint';
import { usePageHorizontalPadding } from '@/hooks/usePagePadding';
import { topNavBarHeight } from '@components/NavBar/TopNavBar/topNavBar.constants';
import React from 'react';
import { YStack, getTokens } from 'tamagui';

export interface TabScreenContainerProps {
  children: React.ReactNode;
}

export const TabScreenContainer = ({
  children,
}: TabScreenContainerProps): React.ReactElement => {
  const { isSmallScreen } = useBreakpoint();
  const horizontalPadding = usePageHorizontalPadding();
  const uiTokens = getTokens();

  return (
    <YStack
      f={1}
      gap="$4"
      paddingTop={
        isSmallScreen ? null : topNavBarHeight + uiTokens.space.$2.val
      }
      paddingBottom="$true"
      paddingHorizontal={horizontalPadding}
      padding={isSmallScreen ? '$true' : null}
    >
      {children}
    </YStack>
  );
};
